/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import apiClient from '../apiClient';
import {
    DocumentsStatDto,
    PaymentTypesStatDto,
    TurnoversByActivitiesDto,
    OperatorCashBoxesStatDto,
    RegistryItemsCountDto,
    DocsCountsStat,
    DevicesCountsByStatuses,
    TurnoversByActivitiesQueryParams,
    CashBoxesStatDto,
} from './dashBoardClient.typings';
import { cutEmptyParams } from '../../../utils/utils';
import {
    FinChartsFilesMap,
    FinChartType,
    TechChartsFilesMap,
    TechChartType,
} from '../../../components/DashboardWitgets/Common/ChartsTyping';

function getPaymentTypesStat(): Promise<PaymentTypesStatDto[]> {
    return apiClient.get<PaymentTypesStatDto[]>('1.0.0/infographics/paymentTypesStat');
}

function getDocumentTypesStat(): Promise<DocumentsStatDto[]> {
    return apiClient.get<DocumentsStatDto[]>('1.0.0/infographics/documentTypesStat');
}

function getTurnoversByActivity(params: TurnoversByActivitiesQueryParams): Promise<TurnoversByActivitiesDto[]> {
    return apiClient.get<TurnoversByActivitiesDto[]>('1.0.0/infographics/turnoverByActivity', cutEmptyParams(params));
}

function getCashBoxesStat(): Promise<CashBoxesStatDto> {
    return apiClient.get('1.0.0/infographics/cashBoxesStat');
}

function getOperatorsCashBoxesStat(): Promise<OperatorCashBoxesStatDto[]> {
    return apiClient.get<OperatorCashBoxesStatDto[]>('1.0.0/infographics/operatorsCashBoxesStat');
}

function getRegistryItemsCountInfo(): Promise<RegistryItemsCountDto> {
    return apiClient.get<RegistryItemsCountDto>('1.0.0/infographics/coverageByTaxationTypes');
}

function getDocumentsCounter(): Promise<DocsCountsStat> {
    return apiClient.get<DocsCountsStat>('1.0.0/infographics/documentsCounter');
}

function getDeviceStatusesStat(): Promise<DevicesCountsByStatuses> {
    return apiClient.get<DevicesCountsByStatuses>('1.0.0/infographics/deviceStatusesStat');
}

async function downloadFinChartData<T>(chartType: FinChartType, params?: T): Promise<ArrayBuffer> {
    return apiClient.downloadFile(FinChartsFilesMap[chartType].endpoint, params);
}

async function downloadTechChartData<T>(chartType: TechChartType, params?: T): Promise<ArrayBuffer> {
    return apiClient.downloadFile(TechChartsFilesMap[chartType].endpoint, params);
}

export const dashBoardClient = {
    getPaymentTypesStat,
    getDocumentTypesStat,
    getTurnoversByActivity,
    getCashBoxesStat,
    getOperatorsCashBoxesStat,
    getRegistryItemsCountInfo,
    getDocumentsCounter,
    getDeviceStatusesStat,
    downloadFinChartData,
    downloadTechChartData,
};
